import { useAssumeContact } from "hooks/mutations/useAssumeContact";
import { useContacts } from "hooks/useContacts";
import { Button } from "styles/Button";
import { AssumeContactButtonProps } from "./types";
import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from '../../assets/close.svg';

export function AssumeContactButton({ onAssumeContact }: AssumeContactButtonProps) {
  const { mutateAsync, isModalOpen, handleConfirm, handleCloseModal } = useAssumeContact();
  const { selectedContact } = useContacts();

  async function handleAssumeContact() {
    await mutateAsync({ contact: selectedContact });
    onAssumeContact();
  }

  return (
    <>
      <Button
        type="button"
        medium={!window.matchMedia("(max-width: 1366px)").matches}
        small={window.matchMedia("(max-width: 1366px)").matches}
        onClick={handleAssumeContact}
      >
        Assumir
      </Button>
      <AssumeConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onClose={handleCloseModal}
      />
    </>
  );
}

type AssumeContactModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export function AssumeConfirmationModal({ isOpen, onConfirm, onClose }: AssumeContactModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content fixed-height"
      style={{
        content: {
          width: '400vw',
          maxWidth: '400px',
          margin: 'auto'
        }
      }}
    >
      <button
        type="button"
        onClick={onClose}
        className="react-modal-close"
      >
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>
      <>
      
      <ModalTitle>Assumir</ModalTitle>
      <p>Este contato já foi assumido, você confirma?</p>
      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <Button onClick={onConfirm}>Confirmar</Button>
        <Button onClick={onClose}>
          Cancelar
        </Button>
      </div>
      </>
    </Modal>
  );
}
